export * from './delete-kunden-art.command.module';
export * from './service';
export * from './component';